import UserPageNavButton from "components/shared/UserPageNavButton";
import React, { useEffect, useState } from "react";
import HomePage from "../HomePage";
import VideosPage from "../VideosPage";
import AboutPage from "../AboutPage";
import LiveTvPage from "../LiveTvPage";
import RadioPage from "../RadioPage";
import PodcastPage from "../PodcastPage";
import MusicPage from "../MusicPage";
import SearchPageSkeleton from "components/skeleton/SearchPageSkeleton";
import PayperviewPage from "../PayperviewPage";

function VideoCreatorButtonSection({
  creatorData,
  isLoading,
  setIsLoading,
}: any) {
  const [isSelected, setIsSelected] = useState<any>(1);
  const [isExpanded, setIsExpanded] = useState(false);

  const [components, setComponents] = useState<any>({
    id: 1,
    component: HomePage,
    name: "Home",
    data: [
      ...(creatorData?.recent_videos || []),
      ...(creatorData?.movies?.data || []),
      ...(creatorData?.series?.data || []),
      ...(creatorData?.playlists || []),
      ...(creatorData?.music || []),
      ...(creatorData?.albums || []),
      ...(creatorData?.tv_channels || []),
      ...(creatorData?.podcasts || []),
      ...(creatorData?.radios || []),
      ...(creatorData?.ppvEvents?.data || []),
    ],
  });

  const filterAndCapitalizeButtons = (creatorData: any) => {
    const filteredButtons = [
      {
        id: 1,
        component: HomePage,
        name: "Home",
        data: [
          ...(creatorData?.recent_videos || []),
          ...(creatorData?.movies?.data || []),
          ...(creatorData?.series?.data || []),
          ...(creatorData?.playlists || []),
          ...(creatorData?.music || []),
          ...(creatorData?.albums || []),
          ...(creatorData?.tv_channels || []),
          ...(creatorData?.podcasts || []),
          ...(creatorData?.radios || []),
          ...(creatorData?.ppvEvents?.data || []),
        ],
      },
      {
        id: 2,
        component: LiveTvPage,
        name: "Live TV",
        data: creatorData?.tv_channels,
      },
      {
        id: 3,
        component: VideosPage,
        name: "Video",
        data: [
          ...(creatorData?.videos || []),
          ...(creatorData?.movies?.data || []),
          ...(creatorData?.series?.data || []),
          ...(creatorData?.playlists || []),
          ...(creatorData?.acted_movies || []),
          ...(creatorData?.acted_tv_shows || []),
          ...(creatorData?.produced_movies || []),
          ...(creatorData?.produced_tv_shows || []),
          ...(creatorData?.directed_movies || []),
          ...(creatorData?.directed_tv_shows || []),
        ],
      },
      {
        id: 5,
        component: MusicPage,
        name: "Music",
        data: [...(creatorData?.music || []), ...(creatorData?.albums || [])],
      },
      {
        id: 6,
        component: PodcastPage,
        name: "Podcast",
        data: creatorData?.podcasts,
      },
      {
        id: 7,
        component: RadioPage,
        name: "Radio",
        data: creatorData?.radios,
      },
      {
        id: 8,
        component: PayperviewPage,
        name: "PPV",
        data: creatorData?.ppvEvents?.data,
      },
      {
        id: 10,
        component: AboutPage,
        name: "About",
        data: [
          ...(creatorData?.videos || []),
          ...(creatorData?.movies?.data || []),
          ...(creatorData?.series?.data || []),
          ...(creatorData?.playlists || []),
          ...(creatorData?.tv_channels || []),
        ],
      },
    ];

    const visibleButtons = filteredButtons.filter((button) => {
      if (button.data) {
        // Check if the data is an array and has elements
        return Array.isArray(button.data) && button.data.length > 0;
      } else {
        return true; // Always show HOME and About buttons
      }
    });

    return visibleButtons.map((button) => ({
      ...button,
      name: button.name,
    }));
  };

  // Usage
  const visibleButtons = filterAndCapitalizeButtons(creatorData);

  useEffect(() => {
    if (visibleButtons.length > 0) {
      setIsSelected(visibleButtons[0].id);
      setComponents({
        id: visibleButtons[0].id,
        component: visibleButtons[0].component,
        name: visibleButtons[0].name,
        data: visibleButtons[0].data,
      });
    }
  }, [creatorData]);

  const handleShowMore = () => {
    const musicButton = visibleButtons.find(
      (button) => button.name === "Music",
    );

    if (musicButton) {
      setIsSelected(musicButton.id);
      setComponents({
        id: musicButton.id,
        component: musicButton.component,
        name: musicButton.name,
        data: musicButton.data,
      });
    }
  };

  const handleCreatorVideoShowMore = () => {
    const videoButton = visibleButtons.find(
      (button) => button.name === "Video",
    );

    if (videoButton) {
      setIsSelected(videoButton.id);
      setComponents({
        id: videoButton.id,
        component: videoButton.component,
        name: videoButton.name,
        data: videoButton.data,
      });
    }
  };

  //logic to see all
  useEffect(() => {
    if (visibleButtons.length > 0) {
      const selectedButton = visibleButtons.find(
        (button) => button.id === isSelected,
      );

      if (selectedButton) {
        setTimeout(() => {
          window.scrollTo({
            top: 100,
            behavior: "smooth",
          });
        }, 500);
        setComponents({
          id: selectedButton.id,
          component: selectedButton.component,
          name: selectedButton.name,
          data: selectedButton.data,
        });
      }
    }
  }, [isSelected]);

  return (
    <>
      {!isLoading && (
        <div className="mt-10 block overflow-hidden rounded-3xl border border-white/5 bg-[#141414] py-2 max-sm:mt-20">
          {/* Tabs */}
          <div className="flex flex-wrap items-center justify-start w-full gap-2 my-5 ml-3 max-sm:mx-0 max-sm:my-3 max-sm:grid max-sm:grid-cols-3 max-sm:gap-1 max-md:grid max-md:grid-cols-4 max-xl:grid max-xl:grid-cols-5 max-2xl:grid-cols-6">
            {visibleButtons.map((button: any, i: number) => (
              <div key={i} className="ml-5 max-sm:ml-3">
                <UserPageNavButton
                  pages={button}
                  setIsSelected={setIsSelected}
                  isSelected={isSelected}
                  selected={button.id === isSelected ? true : false}
                  isLoading={isLoading}
                  setComponents={setComponents}
                />
              </div>
            ))}
          </div>

          <div
            id="section1"
            className="mb-[150px] ml-5 pb-[100px] text-white max-sm:ml-3"
          >
            {components && (
              <components.component
                creatorData={creatorData}
                isLoading={isLoading}
                handleShowMore={handleShowMore}
                handleCreatorVideoShowMore={handleCreatorVideoShowMore}
                isSelected={isSelected}
                setIsSelected={setIsSelected}
              />
            )}
          </div>
        </div>
      )}
      {isLoading && <SearchPageSkeleton />}
    </>
  );
}

export default VideoCreatorButtonSection;
